import React, { Fragment, useEffect, useState, Component, useCallback, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Progress, Label, Input, Spinner, Table, Col, Container, Row, Card, CardBody, CardHeader, Modal, ModalHeader, NavLink, Nav, NavItem, ModalBody, TabContent, TabPane, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Button } from "reactstrap";
import { api } from "../../../config";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import logo from "../../../assets/images/logo-sm.png";
import parse from "html-react-parser";
import classnames from "classnames";
import ModalImage from "react-modal-image";
import ReactApexChart from "react-apexcharts";
import { useReactToPrint } from "react-to-print";
import SimpleBar from "simplebar-react";
import CountUp from "react-countup";
import FeatherIcon from "feather-icons-react";

import moment from "moment";
import { getCivilBudget, resetCivilBudgetState } from "../../../store/civilBudget/action";
import { getCivilProgression, resetCivilProgressionState } from "../../../store/civilProgression/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { getDashboard, resetDashboardState } from "../../../store/dashboard/action";
import { resetCivilBudgetScheduleState, getCivilBudgetSchedule as onGetCivilBudgetSchedules, addNewCivilBudgetSchedule as onAddNewCivilBudgetSchedule, updateCivilBudgetSchedule as onUpdateCivilBudgetSchedule, deleteCivilBudgetSchedule as onDeleteCivilBudgetSchedule, getCivilBudgetScheduleLoading } from "../../../store/civilBudgetSchedule/action";
import { find, isEmpty } from "lodash";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import ExportDoc from "../../../Components/Common/ExportDoc";
import PrintDocx from "../PrintDocx";
import Siteplan from "../Siteplan";

const ProgressDashboard = () => {
  document.title = "Dashboard";
  const printSiteRef = useRef(null);
  const onBeforeGetContentResolve = useRef(null);
  const [loadingPrintSite, setLoadingPrintSite] = useState(false);
  const dispatch = useDispatch();
  const date = new Date().getHours();

  //
  const [modal, setModal] = useState(false);
  const [modalMaterial, setModalMaterial] = useState(false);
  const [label, setLabel] = useState([]);
  const [dashboard, setDashboard] = useState({});
  const [isBuildingProgress, setIsBuildingProgress] = useState(true);
  const [info, setInfo] = useState([]);
  const [svg, setSVG] = useState("");
  const [svgProject, setSVGProject] = useState("");
  const [civilBudgetList, setCivilBudgetList] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [productList, setProductList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [progressList, setProgressList] = useState([]);
  const [progressUnitList, setProgressUnitList] = useState([]);
  const [progressBlokList, setProgressBlockList] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [scheduleDetail, setScheduleDetail] = useState([]);
  const [civilBudgetSelectList, setCivilBudgetSelectList] = useState([]);
  const [civilBudget, setCivilBudget] = useState([]);
  const [expense, setExpense] = useState([]);
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [unit, setUnit] = useState(0);
  const [printDetailDoc, setPrintDetailDoc] = useState([]);
  const expanseDataRef = useRef([]);
  const [filterBy, setFilterBy] = useState("");
  const [chartProjectCategory, setChartProjectCategory] = useState([]);
  const [chartProjectColor, setChartProjectColor] = useState([]);
  const [chartProjectData, setChartProjectData] = useState([
    {
      name: "RAB",
      type: "line",
      data: [],
    },
    {
      name: "RAP",
      type: "line",
      data: [],
    },
  ]);

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, dashboards, loading, error, productVarians, productVarianLoading, civilBudgets, civilBudgetLoading, civilProgressions, civilProgressionLoading, civilBudgetSchedules, civilBudgetScheduleLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    dashboards: state.Dashboard.dashboards,
    loading: state.Dashboard.loading,
    catalogAvailable: state.Catalog.catalogAvailable,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    civilBudgets: state.CivilBudget.civilBudgets,
    civilBudgetLoading: state.CivilBudget.loading,
    civilProgressions: state.CivilProgression.civilProgressions,
    civilProgressionLoading: state.CivilProgression.loading,
    civilBudgetSchedules: state.CivilBudgetSchedule.civilBudgetSchedules,
    civilBudgetScheduleLoading: state.CivilBudgetSchedule.loading,
  }));

  const reactToPrintContent = useCallback(() => {
    return printSiteRef.current;
  }, [printSiteRef]);

  const handleAfterPrint = useCallback(() => { }, []);

  const handleBeforePrint = useCallback(() => { }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrintSite(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrintSite(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrintSite]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className="ri-file-excel-line me-1 align-bottom text-success"></i>;
      case "x-compressed":
        return <i className="ri-file-zip-line me-1 align-bottom text-danger"></i>;
      case "pdf":
        return <i className="ri-file-pdf-line me-1 align-bottom text-danger"></i>;
      default:
        return <i className="ri-image-line me-1  align-bottom text-info "></i>;
    }
  };

  useEffect(() => {
    if (branchSelected && companySelected && clientSelected) {
      setPositionMessage(`${userData?.user?.user_department?.name}, ${userData?.user?.user_position?.name}`);
      handleGetDefault(clientSelected.value, companySelected.value, branchSelected.value, branchSelected.svg_siteplan, branchSelected.svg_rincik, branchSelected.svg_siteplan_project);
    }
  }, [branchSelected, companySelected, clientSelected]);

  useEffect(() => {
    if (!isEmpty(dashboards)) {
      setDashboard(dashboards);
    } else {
      setDashboard({});
    }
  }, [dashboards]);

  const handleGetProductVariant = (companyId, branchId, type) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, branchId: branchId, type: type, status: 2 }));
  };

  const handleCivilBudget = (id, branchId, type) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: id, branchId: branchId }));
  };

  const handleCivilProgression = (id, product) => {
    dispatch(resetCivilProgressionState());
    dispatch(getCivilProgression(product ? { companyId: id, productId: product } : { companyId: id }));
  };

  const [justifyPillsTab, setjustifyPillsTab] = useState("2");
  const justifyPillsToggle = (tab) => {
    if (justifyPillsTab !== tab) {
      setjustifyPillsTab(tab);
    }
  };

  const handleGetDefault = (clientId, companyId, branchId, svg, svg_rincik, svg_siteplan_project) => {
    dispatch(resetDashboardState());
    dispatch(getDashboard({ branchId: branchId, companyId: companyId, clientId: clientId }));
    handleCivilBudget(companyId, branchId, "PROGRESS BANGUNAN");
    handleGetProductVariant(companyId, branchId, 1);
    setSVG(svg);
    setSVGProject(svg_siteplan_project);
    handleCivilProgression(companyId);
  };

  const toggle = useCallback(() => {
    if (modal) {
      handleCivilProgression(companySelected.value);
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  useEffect(() => {
    setProductList(productVarians);
  }, [productVarians]);

  useEffect(() => {
    let list = [];
    let data = [];
    let opt = [];
    civilBudgets.forEach((it, idx) => {
      const name = it.cvl_branch ? it.cvl_branch.name + " - " + it.name : it.name;
      const id = it.id;
      if (it.cvl_branch.id === 1 && companySelected && companySelected.value && it) {
        if (it.type === "PROGRESS BANGUNAN") {
          dispatch(resetCivilBudgetScheduleState());
          dispatch(onGetCivilBudgetSchedules({ civilBudgetId: it.id }));
        }
        setCivilBudget({ label: name, value: id, data: it });
      }
      let obj = { label: name, value: id, data: it };
      opt.push(obj);
      (it.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order) || []).forEach((item, key) => {
        let cat = item.cvld_account && item.cvld_account.cvl_account_category ? item.cvld_account.cvl_account_category.name : "";
        let findCategory = list.find((x) => x.category === cat);
        if (findCategory) {
          findCategory.data.push(item);
        } else {
          list.push({ type: it.type, category: cat, data: [item] });
        }
      });
    });
    setCivilBudgetList(list);

    let option = { options: opt };
    data.push(option);
    setCivilBudgetSelectList(data);
  }, [civilBudgets]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  useEffect(() => {
    if (!isEmpty(civilBudgetSchedules)) {
      setSchedule(civilBudgetSchedules.schedule);
      setScheduleDetail(civilBudgetSchedules.schedule_detail);

      let chartCategory = [];
      let rab = [];
      let rap = [];
      let total_rab = 0;
      let total_rap = 0;
      for (const schedule of civilBudgetSchedules.schedule) {
        chartCategory.push(schedule.date);
        total_rab += parseFloat(schedule.total) > 0 ? parseFloat(schedule.total) : 0;
        total_rap += parseFloat(schedule.total_progress) > 0 ? parseFloat(schedule.total_progress) : 0;
        rab.push(total_rab.toFixed(2));
        rap.push(total_rap.toFixed(2));
      }
      setChartProjectCategory(chartCategory);
      setChartProjectData([
        {
          name: "Rencana Anggaran Belanja",
          type: "line",
          data: rab,
        },
        {
          name: "Rencana Anggaran Pelaksanaan",
          type: "line",
          data: rap,
        },
      ]);

      setChartProjectColor(["#338b39", "#ffaa00"]);
    }
  }, [civilBudgetSchedules]);

  useEffect(() => {
    let arrProgress = [];
    let arrProgressBlock = [];
    let arrBlok = [];
    for (const varian of productList) {
      let block = varian.pvar_product.product_block ? varian.pvar_product.product_block.name : "";
      let name = varian.pvar_product.name;
      let prod = block + "-" + name;
      let progress = dashboards.civil_progress ? dashboards.civil_progress : [];
      let weight = 0;

      let findBlok = arrBlok.find((x) => x.block === block);
      if (!findBlok) {
        arrBlok.push({ block: block, weight: 0, label: block, unit: 1, value: varian?.pvar_product?.product_block?.id });
      } else {
        findBlok.unit += 1;
      }

      for (const detail of progress.sort((a, b) => a.id - b.id)) {
        let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
        let blok = detail.cvlp_product && detail.cvlp_product.product_block && detail.cvlp_product.product_block.name;
        let unit = detail.cvlp_product && detail.cvlp_product.name;
        let key = blok + "-" + unit;

        if (prod === key) {
          for (const acc of civilBudgets) {
            for (const account of acc.cvl_detail) {
              let findCategory = m.indexOf((account?.cvld_account?.id ?? "").toString());
              if (findCategory !== -1) weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
            }
          }
        }
      }
      arrProgress.push({
        name: prod,
        block: block,
        weight: weight.toFixed(2),
      });
    }
    setProgressUnitList(arrProgress.sort((a, b) => (b.name === a.name ? 0 : a.name > b.name ? 1 : -1)));

    arrProgress = [];
    for (const varian of arrBlok) {
      let block = varian.block ? varian.block : "";
      let weight = 0;
      let progress = dashboards.civil_progress ? dashboards.civil_progress : [];

      for (const detail of progress.sort((a, b) => a.id - b.id)) {
        let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
        let blok = detail.cvlp_product && detail.cvlp_product.product_block && detail.cvlp_product.product_block.name;
        if (block === blok) {
          for (const acc of civilBudgets) {
            for (const account of acc.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
              let findCategory = m.indexOf((account?.cvld_account?.id ?? "").toString());
              if (findCategory !== -1) weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
            }
          }
        }
      }
      arrProgressBlock.push({
        block: block,
        weight: weight.toFixed(2),
      });
    }

    setProgressBlockList(
      arrProgressBlock.sort((a, b) => {
        a = a.block.replace(/(\d+)(.)/, "$2$1");
        b = b.block.replace(/(\d+)(.)/, "$2$1");
        return a.localeCompare(b, "en", { numeric: true });
      })
    );

    let data = [];
    let option = { options: arrBlok.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
    data.push(option);

    setBlockList(data);
  }, [dashboards, civilBudgets, productList]);

  useEffect(() => {
    if (!civilBudgetLoading && !loading && !productVarianLoading && isBuildingProgress) {
      const containerSvgEl = document.getElementById("_0");

      if (containerSvgEl) {
        containerSvgEl.childNodes.forEach((el) => {
          if (el.nodeType === 1) {
            el.style.fill = "";
          }
        });
      }

      for (const varian of productList) {
        let block = varian.pvar_product.product_block ? varian.pvar_product.product_block.name : "";
        let name = varian.pvar_product.name;
        let ele = document.getElementById(block + "-" + name);
        if (ele) {
          ele.removeAttribute("class");
          ele.style.fill = "#FFFFFF";
        }
      }

      let arrProgress = [];
      let progress = dashboards.civil_progress ? dashboards.civil_progress : [];
      for (const detail of progress.sort((a, b) => a.id - b.id)) {
        let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
        let blok = detail.cvlp_product && detail.cvlp_product.product_block && detail.cvlp_product.product_block.name;
        let category = detail.cvlp_product && detail.cvlp_product.product_category && detail.cvlp_product.product_category.name;
        let unit = detail.cvlp_product && detail.cvlp_product.name;
        let image = detail.cvlp_product && detail.cvlp_product.image ? `${api.MEDIA_URL}/media/${detail.cvlp_product.image}-w-150` : logo;
        let key = blok + "-" + unit;
        detail.key = key;
        detail.name = category + " - " + key;
        detail.image = image;
        let weight = 0;
        for (const acc of civilBudgets) {
          if (acc.type === "PROGRESS BANGUNAN") {
            for (const account of acc.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
              let findCategory = m.indexOf((account?.cvld_account?.id ?? "").toString());
              if (findCategory !== -1) {
                weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
                let ele = document.getElementById(blok + "-" + unit);
                detail.progress = account?.cvld_account?.name;
                detail.color = account?.cvld_account?.color;
                if (ele) {
                  ele.removeAttribute("class");
                  ele.style.fill = account?.cvld_account?.color;
                }
              }
            }
          }
        }
        detail.weight = weight.toFixed(2);
        arrProgress.push(detail);
      }
      setProgressList(arrProgress);
    }
  }, [svg, isBuildingProgress, dashboards, civilBudgets, civilBudgetLoading, productList, productVarianLoading, justifyPillsTab]);

  useEffect(() => {
    document.body.addEventListener("click", (element) => {
      if (element.target.id) {
        let data = progressList.find((x) => x.key === element.target.id);
        if (data) {
          if (isBuildingProgress) handleCivilProgression(data.companyId, data.productId);
          setInfo(data);
          toggle();
        }
      }
    });
    document.body.addEventListener("mouseover", (element) => {
      if (element.target.id) {
        let data = progressList.find((x) => x.key === element.target.id);
        if (data) {
          setInfo(data);
          let iconPos = document.querySelector("#" + data.key).getBoundingClientRect();
          let mypopup = document.getElementById("dashboard-custom-tooltip");
          mypopup.style.left = iconPos.right < 1000 ? iconPos.right + 10 + "px" : iconPos.right - 460 + 10 + "px";
          mypopup.style.top = window.scrollY + iconPos.top - 60 + "px";
          mypopup.style.display = "block";
        }
      }
    });
    document.body.addEventListener("mouseout", (element) => {
      if (element.target.id) {
        let data = progressList.find((x) => x.key === element.target.id);
        if (data) {
          let mypopup = document.getElementById("dashboard-custom-tooltip");
          mypopup.style.display = "none";
        }
      }
    });
  }, [progressList, isBuildingProgress]);

  const toggleMaterial = useCallback(() => {
    if (modalMaterial) {
      setModalMaterial(false);
    } else {
      setModalMaterial(true);
    }
  }, [modalMaterial]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "name",
        label: "Material",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Jumlah",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "amount" || doc.id === "quantity" || doc.id === "amount_total") {
                doc.data.push(currencyFormat(parseFloat(value || 0) || 0));
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDetailDoc(dataDoc);
  }, [expense]);

  const searchList = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return el.amount.toLowerCase().indexOf(query.toLowerCase()) !== -1 || el.description.toLowerCase().indexOf(query.toLowerCase()) !== -1 || el.transaction_no.toLowerCase().indexOf(query.toLowerCase()) !== -1 || el.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    };

    let filterData = filterItems(expanseDataRef.current, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setExpense(filterData);
  };

  const ParsedSVG = useMemo(() => {
    let content = svgProject && parse(svgProject);

    return <div>{content}</div>;
  }, [svgProject, isBuildingProgress]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Row className="mb-3 pb-1">
                  <Col xs={12}>
                    <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                      <div className="flex-grow-1">
                        <h4 className="fs-16 mb-1">
                          {date < 12 ? "Selamat Pagi" : date >= 12 && date <= 15 ? "Selamat Siang" : date < 18 ? "Selamat Sore" : "Selamat Malam"} {userData?.name}{" "}
                          {(loading || civilBudgetLoading || civilProgressionLoading) && (
                            <>
                              <Spinner color="primary" type="grow" size={"sm"}>
                                Loading...
                              </Spinner>
                              &nbsp;
                              <Spinner color="success" type="grow" size={"sm"}>
                                Loading...
                              </Spinner>
                            </>
                          )}
                        </h4>
                        <p>{userType !== "agent" ? positionMessage : ""}</p>
                      </div>
                      <div className="mt-3 mt-lg-0">
                        <form action="#">
                          <Row className="g-3 mb-0 align-items-center">
                            <div className="col-sm-auto">
                              <div className="input-group">
                                <Flatpickr
                                  className="form-control border-0 dash-filter-picker shadow"
                                  options={{
                                    mode: "range",
                                    dateFormat: "Y/m/d",
                                  }}
                                  onChange={(selectedDates, dateStr) => {
                                    let startat = "";
                                    let endat = "";
                                    let datearr = dateStr.split(" to ");
                                    if (datearr[1]) {
                                      startat = datearr[0];
                                      endat = datearr[1] ? datearr[1] : datearr[0];
                                    }
                                    //dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, startat: startat, endat: endat }));
                                  }}
                                />
                                <div className="input-group-text bg-primary border-primary text-white">
                                  <i className="ri-calendar-2-line"></i>
                                </div>
                                <UncontrolledDropdown className="card-header-dropdown ms-2 mt-2" direction="start">
                                  <DropdownToggle tag="a" className="text-reset" role="button">
                                    <span className="fw-semibold text-uppercase fs-12">Filter by: </span>
                                    <span className="text-muted">
                                      {filterBy} <i className="mdi mdi-chevron-down ms-1"></i>
                                    </span>
                                  </DropdownToggle>
                                  <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Hari Ini");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "today" }));
                                      }}
                                    >
                                      Hari Ini
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Kemarin");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "yesterday" }));
                                      }}
                                    >
                                      Kemarin
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("7 Hari Terakhir");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "last7day" }));
                                      }}
                                    >
                                      7 Hari Terakhir
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("30 Hari Terakhir");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "last30day" }));
                                      }}
                                    >
                                      30 Hari Terakhir
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Bulan Ini");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "thismonth" }));
                                      }}
                                    >
                                      Bulan Ini
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Bulan Lalu");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "lastmonth" }));
                                      }}
                                    >
                                      Bulan Lalu
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </div>
                            </div>
                          </Row>
                        </form>
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl={3} md={6}>
                    <Card className="card-animate">
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <p className="text-uppercase fw-medium text-muted mb-0">
                              TOTAL UNIT
                            </p>
                          </div>
                          <div className="flex-shrink-0"></div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-1">
                          <div>
                            <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                              <CountUp
                                start={0}
                                separator="."
                                decimal=","
                                prefix=""
                                decimals=""
                                end={progressUnitList.length}
                                duration={1}
                                className="counter-value"
                              />
                            </h4>
                          </div>
                          <div className="avatar-xs flex-shrink-0">
                            <span className="avatar-title bg-light rounded fs-3">
                              <FeatherIcon
                                icon="home"
                                className="text-primary icon-dual-success"
                              />
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={3} md={6}>
                    <Card className="card-animate">
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <p className="text-uppercase fw-medium text-muted mb-0">
                              TOTAL UNIT BELUM BERPROGRESS
                            </p>
                          </div>
                          <div className="flex-shrink-0"></div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-1">
                          <div>
                            <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                              <CountUp
                                start={0}
                                separator="."
                                decimal=","
                                prefix=""
                                decimals=""
                                end={progressUnitList.filter(f => parseFloat(f.weight) < 1).length}
                                duration={1}
                                className="counter-value"
                              />
                            </h4>
                          </div>
                          <div className="avatar-xs flex-shrink-0">
                            <span className="avatar-title bg-light rounded fs-3">
                              <FeatherIcon
                                icon="home"
                                className="text-danger icon-dual-danger"
                              />
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xl={3} md={6}>
                    <Card className="card-animate">
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <p className="text-uppercase fw-medium text-muted mb-0">
                              TOTAL UNIT BERPROGRES
                            </p>
                          </div>
                          <div className="flex-shrink-0"></div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-1">
                          <div>
                            <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                              <CountUp
                                start={0}
                                separator="."
                                decimal=","
                                prefix=""
                                decimals=""
                                end={progressUnitList.filter(f => parseFloat(f.weight) < 99 && parseFloat(f.weight) > 0).length}
                                duration={1}
                                className="counter-value"
                              />
                            </h4>
                          </div>
                          <div className="avatar-xs flex-shrink-0">
                            <span className="avatar-title bg-light rounded fs-3">
                              <FeatherIcon
                                icon="home"
                                className="text-warning icon-dual-warning"
                              />
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={3} md={6}>
                    <Card className="card-animate">
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <p className="text-uppercase fw-medium text-muted mb-0">
                              TOTAL UNIT SELESAI
                            </p>
                          </div>
                          <div className="flex-shrink-0"></div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-1">
                          <div>
                            <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                              <CountUp
                                start={0}
                                separator="."
                                decimal=","
                                prefix=""
                                decimals=""
                                end={progressUnitList.filter(f => parseFloat(f.weight) >= 99).length}
                                duration={1}
                                className="counter-value"
                              />
                            </h4>
                          </div>
                          <div className="avatar-xs flex-shrink-0">
                            <span className="avatar-title bg-light rounded fs-3">
                              <FeatherIcon
                                icon="home"
                                className="text-success icon-dual-success"
                              />
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col xl={12}>
                    <Card className="card-height-100">
                      <CardHeader className="align-items-center d-flex gap-2 border-0 pb-0">
                        <h4 className="flex-grow-1 py-2 mb-sm-0 fw-semibold">PROGRES PEMBANGUNAN</h4>
                        <div className="flex-shrink-0">
                          {svgProject && (
                            <div className="d-flex justify-content-end px-3">
                              <button type="submit" className="btn btn-success" onClick={handlePrint}>
                                PRINT SITEPLAN &nbsp;
                                {loadingPrintSite && <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner>}
                              </button>
                            </div>
                          )}
                        </div>

                      </CardHeader>
                      <div style={{ position: "relative" }}>
                        <div ref={printSiteRef}>
                          <CardBody className="siteplan-svg">
                            <Siteplan salesLoading={civilProgressionLoading} justifyPillsTab={justifyPillsTab} component={ParsedSVG} />
                          </CardBody>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col>
            {/* <RecentActivity /> */}
          </Row>

          <Row>
            <Col lg={8}>
              <Card className="" style={{ height: "730px" }}>
                <CardHeader className="border-0 pb-0 align-items-center d-flex">
                  <h4 className="card-title mb-0 flex-grow-1">PROGRESS PEMBANGUNAN BY BLOK</h4>
                </CardHeader>
                <CardBody className="pb-3 pe-0 ps-0">
                  <SimpleBar style={{ maxHeight: "650px" }}>
                    <table className="table border table-responsive table-striped fs-13">
                      <thead className="align-middle">
                        <tr className="table-active text-center fs-13 fw-semibold">
                          <td>BLOK</td>
                          <td>JUMLAH UNIT</td>
                          <td>BOBOT</td>
                          <td></td>
                        </tr>
                      </thead>
                      <tbody>
                        {((progressBlokList || []).sort((a, b) => a.block.localeCompare(b.block, undefined, { numeric: true, sensitivity: "base" })) || []).map((obj, key) => {
                          let tUnit = progressUnitList.filter((item) => item.block === obj.block).length;
                          let percentage = parseFloat(obj.weight / tUnit).toFixed(2);
                          return (
                            <tr key={key} className="text-center fs-14">
                              <td className="fw-semibold">{obj.block}</td>
                              <td className="fs-12">{tUnit}</td>
                              <td className="fs-12">{percentage} %</td>
                              <td className="ps-4 pe-4" style={{ width: "60%" }}>
                                <Progress value={percentage} color={percentage < 50 ? "danger" : percentage < 80 ? "warning" : "success"} className="animated-progess custom-progress progress-label mt-3 w-100">
                                  <div className={percentage < 50 ? "label text-danger bg-soft-danger fs-10" : percentage < 80 ? "label text-warning bg-soft-warning fs-10" : "label text-success bg-soft-success fs-10"}>{percentage} %</div>
                                </Progress>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </SimpleBar>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4}>
              <Card className="" style={{ height: "730px" }}>
                <CardHeader className="border-0 pb-0 align-items-center d-flex">
                  <h4 className="card-title mb-0 p-2 flex-grow-1">UPDATE PROGRESS PEMBANGUNAN TERAKHIR</h4>
                </CardHeader>

                {progressBlokList.length > 0 && (
                  <CardBody className="pe-0 ps-0">
                    <SimpleBar style={{ maxHeight: "630px" }}>
                      {(civilProgressions || []).slice(0, 20).map((item, idx) => {
                        return (
                          <div key={idx} className="accordion-item border-0">
                            <div className="accordion-header">
                              <div className="accordion-button ps-3 pe-3 mb-3 shadow-none" id="headingOne">
                                <div className="d-flex">
                                  <div className="flex-shrink-0 me-1">
                                    {item?.cvlp_createdby && item?.cvlp_createdby?.image ? (
                                      <div className="profile-user position-relative d-inline-block mx-auto">
                                        <img src={`${api.MEDIA_URL}/media/${item?.cvlp_createdby?.image}-w-200`} alt="" className="rounded-circle avatar-sm img-thumbnail user-profile-image" />
                                      </div>
                                    ) : (
                                      <div className="flex-shrink-0 avatar-sm">
                                        <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item?.cvlp_createdby?.name.charAt(0)}</div>
                                      </div>
                                    )}
                                  </div>
                                  <div className="flex-grow-1 ms-3 mt-1">
                                    <h6 className="fs-14 mb-1">
                                      {item.cvlp_createdby.name}{" "}
                                      <small className="text-muted">
                                        <span className="text-dark">{handleValidDate(item.updatedat)}</span> {moment.utc(item.updatedat).local().fromNow()}
                                      </small>
                                    </h6>
                                    <p className="fw-normal text-muted mb-2">
                                      Memperbarui progress pembangunan{" "}
                                      <b className="text-dark">
                                        {item?.cvlp_product?.product_block?.name} {item?.cvlp_product?.name}
                                      </b>{" "}
                                      dengan catatan: {item.description || "-"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </SimpleBar>
                  </CardBody>
                )}
              </Card>
            </Col>
            <Col lg={12} className="">
              <Row>
                <Col sm={12}>
                  <Card className="" style={{ height: "730px" }}>
                    <CardHeader className="border-0 pb-0 align-items-center d-flex">
                      <h4 className="card-title mb-0 flex-grow-1">
                        GRAFIK PROGRESS PROYEK (KURVA S) &nbsp;{" "}
                        {civilBudgetScheduleLoading && (
                          <>
                            <Spinner color="primary" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                            <Spinner color="success" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                          </>
                        )}
                      </h4>
                      <div className="d-flex gap-1">
                        <div style={{ width: "380px" }}>
                          <Select
                            name="budget"
                            value={civilBudget}
                            className="text-uppercase w-100"
                            placeholder="Pilih Aggaran Proyek"
                            onChange={(e) => {
                              setCivilBudget(e.data);
                              setUnit(parseInt(e.data.unit));
                              setStartAt(e.data.startat);
                              setEndAt(e.data.endat);
                              dispatch(resetCivilBudgetScheduleState());
                              dispatch(onGetCivilBudgetSchedules({ civilBudgetId: e.data.id }));
                            }}
                            options={civilBudgetSelectList}
                          ></Select>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <div className="pe-3" style={{ height: "650px" }}>
                        <ReactApexChart
                          options={{
                            chart: {
                              height: 650,
                              type: "line",
                              toolbar: {
                                show: true,
                              },
                            },
                            stroke: {
                              curve: "straight",
                              dashArray: [0, 0, 0, 0, 0, 0],
                              width: [2, 2, 2, 2, 2, 2],
                            },
                            fill: {
                              opacity: [0.5, 1, 1, 1, 1, 1],
                            },
                            markers: {
                              size: [0, 0, 0, 0, 0, 0],
                              strokeWidth: 2,
                              hover: {
                                size: 4,
                              },
                            },
                            xaxis: {
                              categories: chartProjectCategory,
                              axisTicks: {
                                show: false,
                              },
                              axisBorder: {
                                show: false,
                              },
                            },
                            grid: {
                              show: true,
                              xaxis: {
                                lines: {
                                  show: true,
                                },
                              },
                              yaxis: {
                                lines: {
                                  show: false,
                                },
                              },
                              padding: {
                                top: 0,
                                right: -2,
                                bottom: 15,
                                left: 10,
                              },
                            },
                            legend: {
                              show: true,
                              horizontalAlign: "center",
                              offsetX: 0,
                              offsetY: -5,
                              markers: {
                                width: 9,
                                height: 9,
                                radius: 6,
                              },
                              itemMargin: {
                                horizontal: 10,
                                vertical: 0,
                              },
                            },
                            colors: chartProjectColor,
                            tooltip: {
                              theme: "dark",
                              fillSeriesColor: true,
                              style: {
                                fontSize: "12px",
                                color: "#FFFFFF",
                              },
                              y: [
                                {
                                  formatter: function (y) {
                                    if (typeof y !== "undefined") {
                                      return y.toFixed(2);
                                    }
                                    return y;
                                  },
                                },
                                {
                                  formatter: function (y) {
                                    if (typeof y !== "undefined") {
                                      return y.toFixed(2);
                                    }
                                    return y;
                                  },
                                },
                                {
                                  formatter: function (y) {
                                    if (typeof y !== "undefined") {
                                      return y.toFixed(2);
                                    }
                                    return y;
                                  },
                                },
                                {
                                  formatter: function (y) {
                                    if (typeof y !== "undefined") {
                                      return y.toFixed(2);
                                    }
                                    return y;
                                  },
                                },
                                {
                                  formatter: function (y) {
                                    if (typeof y !== "undefined") {
                                      return y.toFixed(2);
                                    }
                                    return y;
                                  },
                                },
                                {
                                  formatter: function (y) {
                                    if (typeof y !== "undefined") {
                                      return y.toFixed(2);
                                    }
                                    return y;
                                  },
                                },
                              ],
                            },
                          }}
                          series={chartProjectData} //chartData
                          type="area"
                          height="650"
                          className="apex-charts"
                        />
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
          <Modal id="showModal" isOpen={modal} centered size="xl">
            <ModalHeader className="bg-light p-3" toggle={toggle}>
              {"PROGRESS PEMBANGUNAN"}
            </ModalHeader>
            {isBuildingProgress ? (
              <ModalBody>
                <CardBody className="pt-4 ps-4 pe-4">
                  <Row className="mb-4">
                    <div className="col-lg-5">
                      {(civilBudgetList || []).map((obj, i) => {
                        let arr = (obj.data || []).filter((f) => f.type === "PROGRESS BANGUNAN");
                        return isBuildingProgress && obj.type === "PROGRESS BANGUNAN" ? (
                          <div key={i} className={"mb-3"}>
                            <p className="fw-semibold fs-14 text-uppercase m-1">{obj.category}</p>
                            <div className={"pe-3 ps-3 row"}>
                              {(arr || []).map((o, idx) => {
                                let ischecked = false;
                                if (info.checked_progress ? (info.checked_progress.split(",").find((x) => x === o.cvld_account.id.toString()) ? true : false) : false) {
                                  ischecked = true;
                                }
                                return (
                                  <div key={idx} className="hstack gap 2 mb-2">
                                    <em className="avatar-xs rounded-circle" style={{ background: o.cvld_account.color, width: "20px", height: "18px", display: "block", float: "left" }}>
                                      &nbsp;
                                    </em>
                                    <div className="ms-2">
                                      <Label className={ischecked ? "form-check-label fw-semibold fs-12 text-uppercase" : "form-check-label fs-12 text-uppercase text-muted"}>
                                        <i className={ischecked ? "mt-2 fs-14 ri-check-line fw-semibold text-success me-1" : "mt-2 fs-14 ri-close-line me-1"}></i> {o.cvld_account.name}
                                      </Label>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : null
                      })}
                    </div>
                    <div className="col-lg-7">
                      <h4 className="card-title mb-4 flex-grow-1">
                        History progress &nbsp;
                        {civilProgressionLoading && (
                          <>
                            <Spinner color="primary" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                            <Spinner color="success" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                          </>
                        )}
                      </h4>
                      <div className="accordionflush">
                        {(civilProgressions || []).map((item, idx) => {
                          return (
                            <div key={idx} className="accordion-item border-0">
                              <div className="accordion-header">
                                <div className="accordion-button p-2 shadow-none" id="headingOne">
                                  <div className="d-flex w-100">
                                    <div className="flex-shrink-0 me-1">
                                      {item?.cvlp_createdby && item?.cvlp_createdby?.image ? (
                                        <div className="profile-user position-relative d-inline-block mx-auto">
                                          <img src={`${api.MEDIA_URL}/media/${item?.cvlp_createdby?.image}-w-200`} alt="" className="rounded-circle avatar-sm img-thumbnail user-profile-image" />
                                        </div>
                                      ) : (
                                        <div className="flex-shrink-0 avatar-sm">
                                          <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item?.cvlp_createdby?.name.charAt(0)}</div>
                                        </div>
                                      )}
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <h6 className="fs-14 mb-1">{item.cvlp_createdby.name}</h6>
                                        {item.cvlp_file.length > 0 && <PrintDocx data={item} />}
                                      </div>
                                      <p className="fw-normal text-muted mb-1">Memperbarui progress pembangunan dengan catatan:</p>
                                      <p className="fw-normal mb-1">{item.description || "-"}</p>
                                      <small className="text-muted">
                                        <span className="text-dark">{handleValidDate(item.createdat)}</span> {moment.utc(item.createdat).local().fromNow()}
                                      </small>

                                      <div className="row mt-3">
                                        {item.cvlp_file.map((f, i) => {
                                          return (
                                            <div key={i} className="col-lg-4">
                                              <div className="position-relative d-inline-block mx-auto">
                                                <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-lg img-thumbnail user-profile-image" />
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </Row>
                </CardBody>
              </ModalBody>
            ) : (
              <ModalBody>
                <CardBody className="pt-4 ps-4 pe-4">{info.description && parse(info.description)}</CardBody>
              </ModalBody>
            )}
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button type="button" className="btn btn-lg btn-light" onClick={toggle}>
                  TUTUP
                </button>
              </div>
            </div>
          </Modal>
          <Modal id="showModal" isOpen={modalMaterial} centered size="xl">
            <ModalHeader className="bg-light p-3" toggle={toggleMaterial}>
              DETAIL REALISASI ANGGARAN {label}
            </ModalHeader>
            <ModalBody>
              <CardBody>
                <div>
                  <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                    <div className="col-sm-10">
                      <Row className="m-0 p-0 ">
                        <div className="fw-semibold col-sm-5 text-start">
                          <input className="search-box  w-100 form-control" placeholder="Filter Material / Transaksi" onChange={(e) => searchList(e.target.value)} />
                        </div>
                      </Row>
                    </div>
                    <div className="col-sm-2 text-end">
                      <ExportDoc data={printDetailDoc} />
                    </div>
                  </Row>
                  <SimpleBar style={{ height: "380px" }}>
                    <Table className="table-border text-center table-hover table-nowrap align-middle mb-0">
                      <thead className="align-middle">
                        <tr className="table-active">
                          <td style={{ width: "20px" }}>
                            <input
                              type="checkbox"
                              className="checkboxDetailAll me-2 form-check-input"
                              checked={expense.every((item) => item.isChecked)}
                              onChange={() => {
                                const allChecked = expense.every((item) => item.isChecked);
                                const updatedData = expense.map((item) => ({
                                  ...item,
                                  isChecked: !allChecked,
                                }));
                                setExpense(updatedData);
                              }}
                            />
                          </td>
                          <td className="text-center" style={{ width: "170px" }}>
                            Tanggal
                          </td>
                          <td>Material</td>
                          <td className="text-center" style={{ width: "170px" }}>
                            No Transaksi
                          </td>
                          <td className="text-center" style={{ width: "170px" }}>
                            Jumlah
                          </td>
                          <td className="text-center">Keterangan</td>
                        </tr>
                      </thead>
                      <tbody id="newlink">
                        {(expense || []).map((o, i) => {
                          return (
                            <tr key={i} id={i} className="product">
                              <td className="product-id">
                                <input
                                  type="checkbox"
                                  className="checkboxDetail me-2 form-check-input"
                                  checked={o.isChecked}
                                  onChange={() => {
                                    const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                    setExpense(updatedData);
                                  }}
                                />{" "}
                                {i + 1}
                              </td>
                              <td className="text-center">{handleValidDate(o.transactionat)}</td>
                              <td className="text-start">{o.name}</td>
                              <td className="text-center">{o.transaction_no}</td>
                              <td className="text-center">{currencyFormat(parseFloat(o.amount))}</td>
                              <td className="text-center">{o.description}</td>
                            </tr>
                          );
                        })}
                        {expense.length === 0 && (
                          <tr>
                            <td colSpan="7" className="p-3 text-center">
                              Belum ada realisasi
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </SimpleBar>
                </div>
              </CardBody>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalMaterial(false);
                  }}
                >
                  TUTUP
                </button>
              </div>
            </div>
          </Modal>
          <Card id="dashboard-custom-tooltip" className="border">
            <CardBody className={info && info.weight ? "" : "d-none"}>
              <div className="d-flex align-items-center mb-3">
                <div className="avatar-md me-3 flex-shrink-0">
                  <div className="avatar-title bg-soft-info rounded">
                    <img src={info.image} alt="" className="avatar-md" />
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h5 className="fs-15 fw-bold mb-1">{info && info.name}</h5>
                  <div className="mb-1">
                    Bobot Tercapai <span className="fw-semibold">{info.weight ? info.weight : 0} %</span>
                  </div>
                  <div className="mb-1" style={{ clear: "both" }}>
                    <em className="avatar-xs" style={{ background: info.color, width: "22px", height: "22px", display: "block", float: "left", marginRight: "5px" }}>
                      &nbsp;
                    </em>{" "}
                    {info.progress}
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProgressDashboard;
